import React, { useState } from 'react';
import { Box, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

// Define styles that simulate different email clients.
const emailClientStyles = {
  gmail: {
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#ffffff',
    color: '#000000',
    padding: '10px',
    lineHeight: '1.5',
  },
  outlook: {
    fontFamily: 'Calibri, sans-serif',
    backgroundColor: '#f8f8f8',
    color: '#000000',
    padding: '10px',
    lineHeight: '1.6',
  },
  apple: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "San Francisco", "Helvetica Neue", Helvetica, Arial, sans-serif',
    backgroundColor: '#ffffff',
    color: '#000000',
    padding: '10px',
    lineHeight: '1.5',
  },
};

const selectStyles = {
  // Label text
  '& .MuiFormLabel-root': {
    color: '#fff',
  },
  // The arrow icon
  '& .MuiSvgIcon-root': {
    color: '#fff',
  },
  // The select trigger (closed state)
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    '& fieldset': {
      borderColor: '#fff',
    },
    '&:hover fieldset': {
      borderColor: '#fff',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#fff',
    },
  },
  // The opened menu
  '& .MuiPaper-root': {
    backgroundColor: '#1E1E1E',
  },
  // Menu items
  '& .MuiMenuItem-root': {
    color: '#fff',
    backgroundColor: '#1E1E1E',
    '&:hover': {
      backgroundColor: '#333', // slightly lighter or darker if you want
    },
  },
};

const EmailClientSimulator = ({ htmlContent }) => {
  const [client, setClient] = useState('gmail');

  const handleClientChange = (e) => {
    setClient(e.target.value);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <FormControl size="small" sx={{ minWidth: 200, mb: 2, ...selectStyles }}>
        <InputLabel id="client-select-label">Email Client</InputLabel>
        <Select
          labelId="client-select-label"
          value={client}
          label="Email Client"
          onChange={handleClientChange}
        >
          <MenuItem value="gmail">Gmail</MenuItem>
          <MenuItem value="outlook">Outlook</MenuItem>
          <MenuItem value="apple">Apple Mail</MenuItem>
        </Select>
      </FormControl>

      <Typography variant="subtitle1" sx={{ mb: 2, color: '#fff' }}>
        Client Preview ({client})
      </Typography>

      <Box
        style={{
          border: '1px solid #ccc',
          padding: '10px',
          minHeight: '300px',
          overflowY: 'auto',
          backgroundColor: emailClientStyles[client].backgroundColor,
          color: emailClientStyles[client].color,
          fontFamily: emailClientStyles[client].fontFamily,
          lineHeight: emailClientStyles[client].lineHeight,
        }}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </Box>
  );
};

export default EmailClientSimulator;
